/**
 * @file OrdersHistory.jsx
 * @description Manages display and handling of trading order history
 *
 * @section Responsibilities
 * - Display order history
 * - Handle order data
 * - Process historical data
 * - Manage history state
 * - Handle history errors
 * - Provide history controls
 *
 * @section Dependencies
 * - HistoryService: History management
 * - DataService: Data processing
 * - StateService: State management
 * - ControlService: Control handling
 *
 * @section Integration Points
 * - History API: History operations
 * - Data System: Data processing
 * - State System: State management
 * - Control System: History controls
 *
 * @section State Management
 * - historyState: History status
 * - dataState: Data status
 * - controlState: Control status
 * - errorState: Error handling
 *
 * @section Events
 * - onHistoryUpdate: History updates
 * - onDataProcess: Data processing
 * - onStateChange: State updates
 * - onError: Error handling
 *
 * @section Props
 * @prop {Array} orders - Order history
 * @prop {Function} onUpdate - Update callback
 * @prop {Object} initialData - Initial history data
 * @prop {Boolean} autoUpdate - Controls auto-updates
 */

import React from "react";
import Widget from "../Widget";

function OrdersHistory({ strategyId, orders }) {
  return (
    <Widget name={"orders-history"} width={"full-width"}>
      <div className="heading">
        <h2 className="left-title">Orders history</h2>
        <table className="basic-table">
          <thead>
            <tr>
              <th>Symbol</th>
              <th>Side</th>
              <th>Qty</th>
              <th>Type</th>
              <th>Dur.</th>
              <th>Filled/Qty</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {orders?.length > 0 ? (
              <>
                {orders.map((order, index) => (
                  <tr key={`order-${index}`}>
                    <td className="symbol first">
                      <p className="order-text">{order.symbol}</p>
                    </td>
                    <td className="side">
                      <p className="order-text">{order.side}</p>
                    </td>
                    <td className="qty">
                      <p className="order-text">{order.quantity}</p>
                    </td>
                    <td className="type">
                      <p className="order-text">{order.type}</p>
                    </td>
                    <td className="dur">
                      <p className="order-text">{order.duration}</p>
                    </td>
                    <td className="filled">
                      <p className="order-text">{order.last_fill_quantity}</p>
                    </td>
                    <td className="status">
                      <p className="order-text">{order.status}</p>
                    </td>
                  </tr>
                ))}
              </>
            ) : (
              <tr>
                <td colSpan={7}>No active orders</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </Widget>
  );
}

export default OrdersHistory;
